import React from 'react'

const CategoryTemplateManagementSubcategory: React.FC = () => (
  <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_2242_11392)" />
    <path
      d="M31.8889 21H22.5556C22.143 21 21.7473 21.1639 21.4556 21.4556C21.1639 21.7473 21 22.143 21 22.5556V31.8889C21 32.3014 21.1639 32.6971 21.4556 32.9888C21.7473 33.2806 22.143 33.4444 22.5556 33.4444H31.8889C32.3014 33.4444 32.6971 33.2806 32.9888 32.9888C33.2806 32.6971 33.4444 32.3014 33.4444 31.8889V22.5556C33.4444 22.143 33.2806 21.7473 32.9888 21.4556C32.6971 21.1639 32.3014 21 31.8889 21ZM47.4444 36.5556H38.1111C37.6986 36.5556 37.3029 36.7194 37.0112 37.0112C36.7194 37.3029 36.5556 37.6986 36.5556 38.1111V47.4444C36.5556 47.857 36.7194 48.2527 37.0112 48.5444C37.3029 48.8361 37.6986 49 38.1111 49H47.4444C47.857 49 48.2527 48.8361 48.5444 48.5444C48.8361 48.2527 49 47.857 49 47.4444V38.1111C49 37.6986 48.8361 37.3029 48.5444 37.0112C48.2527 36.7194 47.857 36.5556 47.4444 36.5556ZM42.7778 21C39.3462 21 36.5556 23.7907 36.5556 27.2222C36.5556 30.6538 39.3462 33.4444 42.7778 33.4444C46.2093 33.4444 49 30.6538 49 27.2222C49 23.7907 46.2093 21 42.7778 21ZM27.2222 36.5556C23.7907 36.5556 21 39.3462 21 42.7778C21 46.2093 23.7907 49 27.2222 49C30.6538 49 33.4444 46.2093 33.4444 42.7778C33.4444 39.3462 30.6538 36.5556 27.2222 36.5556Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2242_11392"
        x1="34.5455"
        y1="0"
        x2="34.5455"
        y2="70"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF005C" />
        <stop offset="1" stopColor="#BD0044" />
      </linearGradient>
    </defs>
  </svg>
)

export default CategoryTemplateManagementSubcategory
